// extracted by mini-css-extract-plugin
export default {"image-slider":"VljBk4VneSgIfUo1iLNL","responsive-slider":"m08n773BwFOAnc3iuUeF","empty":"nj7tbCUWktPPFtbd2oOa"};